
import { Component, Vue, Prop, Watch, Getter } from "nuxt-property-decorator";
import { BIcon, BIconListUl, BIconXLg } from "bootstrap-vue";

@Component({
  components: {
    BIcon,
    BIconListUl,
    BIconXLg,
  },
})
export default class TheMapView extends Vue {
  @Prop() items: any;
  @Prop() isMap: boolean;
  @Prop() initialLat!: number;
  @Prop() initialLng!: number;
  @Prop() isAsta!: boolean;

  @Prop({ default: 25 }) perPage: number;
  @Prop({ default: 0 }) totalRows: number;

  @Prop() fetchState!: any;

  @Getter("filter/filterCount") filtersCount: number;
  @Getter("filter/getFilter") filterObj!: any;

  public isMobile: boolean = true;
  public originalFilters: any = null;
  public bodyClass: string = "";

  @Watch("isMap")
  copyFilters() {
    this.originalFilters = { ...this.filterObj };
    this.bodyClass = this.isMap ? "overflow-hidden" : "";
  }

  public head() {
    return {
      bodyAttrs: {
        class: this.bodyClass,
      },
    };
  }

  mounted() {
    if (process.client) {
      this.isMobile = window.innerWidth < 991;
    }
  }

  public data: any;
  public active: string | null = null;

  public makeItActive(index: string) {
    this.active = index;
  }

  public changePage(pageNumber: number) {
    this.$emit("change-page", pageNumber);
  }

  public toggleModal() {
    this.$store.commit("modal/toggleModal");
  }

  public closeMap(resetPosition: boolean = false) {
    this.$store.commit("layout/setOpenSearchMap", false);

    if (resetPosition) {
      this.$store.commit("filter/resetPosition");
      this.$store.commit("filter/cloneFilterFromFilterMap", this.originalFilters);
    }

    this.$emit("bounds-changed");
  }

  // committo il reset e lancio un search sfruttando l'evento bounds-changed
  public removeFilter(filter: string) {
    this.$store.commit(filter);
    this.$emit("bounds-changed");
  }
}
